import React, { ForwardedRef } from 'react';
import { ConeBufferGeometry, CylinderGeometry, Mesh } from 'three';
import { MeshProps } from '@react-three/fiber/dist/declarations/src/three-types';
import { BufferGeometryUtils } from 'three/examples/jsm/utils/BufferGeometryUtils';
import FlatColorMaterial from '../materials/FlatColorMaterial';

const geom = createGeometry();

type Props = MeshProps & {
    color?: number,
};

const SphereArrow = React.forwardRef(({ color, ...props }: Props, ref?: ForwardedRef<Mesh>) =>
{
  return <mesh {...props} geometry={geom} ref={ref} >
    <FlatColorMaterial color={color} flattenPerspective/>
  </mesh>;
});

SphereArrow.displayName = 'Arrow';

function createGeometry()
{
  const coneHeight = 0.1;
  const cylHeight = 1.0 - coneHeight;
  const radius = 0.01;

  const cylinderGeom = new CylinderGeometry(radius, radius, cylHeight);
  cylinderGeom.translate(0.0, cylHeight * .5, 0.0);

  const coneGeom = new ConeBufferGeometry(0.025, coneHeight);
  coneGeom.translate(0.0, 1.0 - coneHeight, 0.0);

  return BufferGeometryUtils.mergeBufferGeometries([ cylinderGeom, coneGeom ]);
}

export default SphereArrow;
